import {
  AwaitingStocktakingCounts,
  StoreStocktakingItem
} from "../../models/Stocktaking";
import { Result } from "../../result";
import { ProblemDetails } from "../../models/Http";

// -------------------------------------------------------

export const REQUEST_AWAITING_STOCKTAKING_COUNTS =
  "REQUEST_AWAITING_STOCKTAKING_COUNTS";

export const REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS =
  "REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS";

export const REQUEST_AWAITING_STORE_CLUSTER_STOCKTAKING_ITEMS =
  "REQUEST_AWAITING_STORE_CLUSTER_STOCKTAKING_ITEMS";

// -------------------------------------------------------

export interface FetchAwaitingStoreStocktakingItems {
  type: typeof REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS;
  payload: Result<ProblemDetails, ReadonlyArray<StoreStocktakingItem>>;
}

export interface FetchAwaitingStocktakingCounts {
  type: typeof REQUEST_AWAITING_STOCKTAKING_COUNTS;
  payload: Result<ProblemDetails, AwaitingStocktakingCounts>;
}

// -------------------------------------------------------

export interface AwaitingStoreStocktakingItemsState {
  stocktakingItems: Result<ProblemDetails, ReadonlyArray<StoreStocktakingItem>>;
}

export interface AwaitingStocktakingCountsState {
  awaitingStoreStocktakingCounts: Result<
    ProblemDetails,
    AwaitingStocktakingCounts
  >;
}

// -------------------------------------------------------

export type StocktakingActionTypes =
  | FetchAwaitingStocktakingCounts
  | FetchAwaitingStoreStocktakingItems;
